// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"0bd16110","453":"c24ffd0d"}[chunkId] + ".chunk.js";
};